import React from "react";

import TournamentAboutOverview from "./components/TournamentAboutOverview";
import TournamentAudienceSection from "./components/TournamentAudienceSection";
import TournamentWorkflowSection from "./components/TournamentWorkflowSection";

export default function AboutMonAppliClubTournoi({
  onDemoClick,
}) {
  return (
    <section className="relative overflow-hidden bg-white py-16 dark:bg-slate-950 sm:py-20 lg:py-24">
      <div className="pointer-events-none absolute left-1/2 top-10 h-72 w-72 -translate-x-1/2 rounded-full bg-orange-300/10 blur-3xl dark:bg-orange-500/5" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <TournamentAboutOverview
          onDemoClick={onDemoClick}
        />

        <TournamentWorkflowSection />

        <TournamentAudienceSection
          onDemoClick={onDemoClick}
        />
      </div>
    </section>
  );
}